/**
 * created by lei lei
 *西工大文字按钮
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";
import eventProxy from "../../../../utils/eventProxy";

export default class OneBtn extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let btn = this.props.btn;
        let Left= btn.marginLeft||0;

        return (
            <div  style={{
                fontSize: 14,
                fontWeight: 400,
                marginLeft:17,
                color:'#0050B3',
            }} onClick={() => {
                this.props.btnClick && this.props.btnClick()
            }}>{this.props.btnText}</div>

          // <Button style={{marginLeft:Left,color: "#fff",}} onClick={()=>{this.btnClick(this.props.record)}}>{this.props.btnText}</Button>

        )
    }
    btnClick(record){
        window.location.hash = `/newsActivityIndex/newsActivityIndex`;
        setTimeout(() => {
            eventProxy.trigger('add',record.id)
        },0);
        return;

    }

}